module.exports = __webpack_public_path__ + "4b2b84595a3a317f733a5bf1d140b423.svg";